export default __webpack_public_path__ + "static/media/Logo-Hanson-09-07-58-046.5f1f90b2.svg";